module.exports = {
	"contract_name": "Exchange",
	"abi": [
		{
			"constant": true,
			"inputs": [
				{
					"name": "numerator",
					"type": "uint256"
				},
				{
					"name": "denominator",
					"type": "uint256"
				},
				{
					"name": "target",
					"type": "uint256"
				}
			],
			"name": "isRoundingError",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "bytes32"
				}
			],
			"name": "filled",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "bytes32"
				}
			],
			"name": "cancelled",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "orderAddresses",
					"type": "address[5][]"
				},
				{
					"name": "orderValues",
					"type": "uint256[6][]"
				},
				{
					"name": "fillTakerTokenAmount",
					"type": "uint256"
				},
				{
					"name": "shouldThrowOnInsufficientBalanceOrAllowance",
					"type": "bool"
				},
				{
					"name": "v",
					"type": "uint8[]"
				},
				{
					"name": "r",
					"type": "bytes32[]"
				},
				{
					"name": "s",
					"type": "bytes32[]"
				}
			],
			"name": "fillOrdersUpTo",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "orderAddresses",
					"type": "address[5]"
				},
				{
					"name": "orderValues",
					"type": "uint256[6]"
				},
				{
					"name": "cancelTakerTokenAmount",
					"type": "uint256"
				}
			],
			"name": "cancelOrder",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "ZRX_TOKEN_CONTRACT",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "orderAddresses",
					"type": "address[5][]"
				},
				{
					"name": "orderValues",
					"type": "uint256[6][]"
				},
				{
					"name": "fillTakerTokenAmounts",
					"type": "uint256[]"
				},
				{
					"name": "v",
					"type": "uint8[]"
				},
				{
					"name": "r",
					"type": "bytes32[]"
				},
				{
					"name": "s",
					"type": "bytes32[]"
				}
			],
			"name": "batchFillOrKillOrders",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "orderAddresses",
					"type": "address[5]"
				},
				{
					"name": "orderValues",
					"type": "uint256[6]"
				},
				{
					"name": "fillTakerTokenAmount",
					"type": "uint256"
				},
				{
					"name": "v",
					"type": "uint8"
				},
				{
					"name": "r",
					"type": "bytes32"
				},
				{
					"name": "s",
					"type": "bytes32"
				}
			],
			"name": "fillOrKillOrder",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "orderHash",
					"type": "bytes32"
				}
			],
			"name": "getUnavailableTakerTokenAmount",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "signer",
					"type": "address"
				},
				{
					"name": "hash",
					"type": "bytes32"
				},
				{
					"name": "v",
					"type": "uint8"
				},
				{
					"name": "r",
					"type": "bytes32"
				},
				{
					"name": "s",
					"type": "bytes32"
				}
			],
			"name": "isValidSignature",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "numerator",
					"type": "uint256"
				},
				{
					"name": "denominator",
					"type": "uint256"
				},
				{
					"name": "target",
					"type": "uint256"
				}
			],
			"name": "getPartialAmount",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "TOKEN_TRANSFER_PROXY_CONTRACT",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "orderAddresses",
					"type": "address[5][]"
				},
				{
					"name": "orderValues",
					"type": "uint256[6][]"
				},
				{
					"name": "fillTakerTokenAmounts",
					"type": "uint256[]"
				},
				{
					"name": "shouldThrowOnInsufficientBalanceOrAllowance",
					"type": "bool"
				},
				{
					"name": "v",
					"type": "uint8[]"
				},
				{
					"name": "r",
					"type": "bytes32[]"
				},
				{
					"name": "s",
					"type": "bytes32[]"
				}
			],
			"name": "batchFillOrders",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "orderAddresses",
					"type": "address[5][]"
				},
				{
					"name": "orderValues",
					"type": "uint256[6][]"
				},
				{
					"name": "cancelTakerTokenAmounts",
					"type": "uint256[]"
				}
			],
			"name": "batchCancelOrders",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "orderAddresses",
					"type": "address[5]"
				},
				{
					"name": "orderValues",
					"type": "uint256[6]"
				},
				{
					"name": "fillTakerTokenAmount",
					"type": "uint256"
				},
				{
					"name": "shouldThrowOnInsufficientBalanceOrAllowance",
					"type": "bool"
				},
				{
					"name": "v",
					"type": "uint8"
				},
				{
					"name": "r",
					"type": "bytes32"
				},
				{
					"name": "s",
					"type": "bytes32"
				}
			],
			"name": "fillOrder",
			"outputs": [
				{
					"name": "filledTakerTokenAmount",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "orderAddresses",
					"type": "address[5]"
				},
				{
					"name": "orderValues",
					"type": "uint256[6]"
				}
			],
			"name": "getOrderHash",
			"outputs": [
				{
					"name": "",
					"type": "bytes32"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "EXTERNAL_QUERY_GAS_LIMIT",
			"outputs": [
				{
					"name": "",
					"type": "uint16"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "VERSION",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "_zrxToken",
					"type": "address"
				},
				{
					"name": "_tokenTransferProxy",
					"type": "address"
				}
			],
			"payable": false,
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "maker",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "taker",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "feeRecipient",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "makerToken",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "takerToken",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "filledMakerTokenAmount",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "filledTakerTokenAmount",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "paidMakerFee",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "paidTakerFee",
					"type": "uint256"
				},
				{
					"indexed": true,
					"name": "tokens",
					"type": "bytes32"
				},
				{
					"indexed": false,
					"name": "orderHash",
					"type": "bytes32"
				}
			],
			"name": "LogFill",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "maker",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "feeRecipient",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "makerToken",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "takerToken",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "cancelledMakerTokenAmount",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "cancelledTakerTokenAmount",
					"type": "uint256"
				},
				{
					"indexed": true,
					"name": "tokens",
					"type": "bytes32"
				},
				{
					"indexed": false,
					"name": "orderHash",
					"type": "bytes32"
				}
			],
			"name": "LogCancel",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "errorId",
					"type": "uint8"
				},
				{
					"indexed": true,
					"name": "orderHash",
					"type": "bytes32"
				}
			],
			"name": "LogError",
			"type": "event"
		}
	],
	"unlinked_binary": "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",
	"networks": {
		"1": {
			"links": {},
			"events": {
				"0x0d0b9391970d9a25552f37d436d2aae2925e2bfe1b2a923754bada030c498cb3": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "maker",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "taker",
							"type": "address"
						},
						{
							"indexed": true,
							"name": "feeRecipient",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "makerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "takerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "filledMakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "filledTakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "paidMakerFee",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "paidTakerFee",
							"type": "uint256"
						},
						{
							"indexed": true,
							"name": "tokens",
							"type": "bytes32"
						},
						{
							"indexed": false,
							"name": "orderHash",
							"type": "bytes32"
						}
					],
					"name": "LogFill",
					"type": "event"
				},
				"0x67d66f160bc93d925d05dae1794c90d2d6d6688b29b84ff069398a9b04587131": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "maker",
							"type": "address"
						},
						{
							"indexed": true,
							"name": "feeRecipient",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "makerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "takerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "cancelledMakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "cancelledTakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": true,
							"name": "tokens",
							"type": "bytes32"
						},
						{
							"indexed": false,
							"name": "orderHash",
							"type": "bytes32"
						}
					],
					"name": "LogCancel",
					"type": "event"
				},
				"0x36d86c59e00bd73dc19ba3adfe068e4b64ac7e92be35546adeddf1b956a87e90": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "errorId",
							"type": "uint8"
						},
						{
							"indexed": true,
							"name": "orderHash",
							"type": "bytes32"
						}
					],
					"name": "LogError",
					"type": "event"
				}
			},
			"updated_at": 1502480340000,
			"address": "0x12459C951127e0c374FF9105DdA097662A027093"
		},
		"42": {
			"links": {},
			"events": {
				"0x0d0b9391970d9a25552f37d436d2aae2925e2bfe1b2a923754bada030c498cb3": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "maker",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "taker",
							"type": "address"
						},
						{
							"indexed": true,
							"name": "feeRecipient",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "makerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "takerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "filledMakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "filledTakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "paidMakerFee",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "paidTakerFee",
							"type": "uint256"
						},
						{
							"indexed": true,
							"name": "tokens",
							"type": "bytes32"
						},
						{
							"indexed": false,
							"name": "orderHash",
							"type": "bytes32"
						}
					],
					"name": "LogFill",
					"type": "event"
				},
				"0x67d66f160bc93d925d05dae1794c90d2d6d6688b29b84ff069398a9b04587131": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "maker",
							"type": "address"
						},
						{
							"indexed": true,
							"name": "feeRecipient",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "makerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "takerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "cancelledMakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "cancelledTakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": true,
							"name": "tokens",
							"type": "bytes32"
						},
						{
							"indexed": false,
							"name": "orderHash",
							"type": "bytes32"
						}
					],
					"name": "LogCancel",
					"type": "event"
				},
				"0x36d86c59e00bd73dc19ba3adfe068e4b64ac7e92be35546adeddf1b956a87e90": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "errorId",
							"type": "uint8"
						},
						{
							"indexed": true,
							"name": "orderHash",
							"type": "bytes32"
						}
					],
					"name": "LogError",
					"type": "event"
				}
			},
			"updated_at": 1502391794390,
			"address": "0x90fe2af704b34e0224bf2299c838e04d4dcf1364"
		},
		"50": {
			"links": {},
			"events": {
				"0x0d0b9391970d9a25552f37d436d2aae2925e2bfe1b2a923754bada030c498cb3": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "maker",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "taker",
							"type": "address"
						},
						{
							"indexed": true,
							"name": "feeRecipient",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "makerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "takerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "filledMakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "filledTakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "paidMakerFee",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "paidTakerFee",
							"type": "uint256"
						},
						{
							"indexed": true,
							"name": "tokens",
							"type": "bytes32"
						},
						{
							"indexed": false,
							"name": "orderHash",
							"type": "bytes32"
						}
					],
					"name": "LogFill",
					"type": "event"
				},
				"0x67d66f160bc93d925d05dae1794c90d2d6d6688b29b84ff069398a9b04587131": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "maker",
							"type": "address"
						},
						{
							"indexed": true,
							"name": "feeRecipient",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "makerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "takerToken",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "cancelledMakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": false,
							"name": "cancelledTakerTokenAmount",
							"type": "uint256"
						},
						{
							"indexed": true,
							"name": "tokens",
							"type": "bytes32"
						},
						{
							"indexed": false,
							"name": "orderHash",
							"type": "bytes32"
						}
					],
					"name": "LogCancel",
					"type": "event"
				},
				"0x36d86c59e00bd73dc19ba3adfe068e4b64ac7e92be35546adeddf1b956a87e90": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "errorId",
							"type": "uint8"
						},
						{
							"indexed": true,
							"name": "orderHash",
							"type": "bytes32"
						}
					],
					"name": "LogError",
					"type": "event"
				}
			},
			"updated_at": 1503318938231,
			"address": "0xb69e673309512a9d726f87304c6984054f87a93b"
		}
	},
	"schema_version": "0.0.5",
	"updated_at": 1503318938231
};


//////////////////
// WEBPACK FOOTER
// ./~/0x.js/lib/src/artifacts/Exchange.json
// module id = 368
// module chunks = 2